import { CastStoneViewStore } from "@intrasync/cast-stone";

const castStoneStoreList = [
  { name: "castStoneViewStore", store: CastStoneViewStore },
];

export default castStoneStoreList;
